import { render, staticRenderFns } from "./part-send-button.vue?vue&type=template&id=da034a98&scoped=true&lang=pug"
import script from "./part-send-button.vue?vue&type=script&lang=js"
export * from "./part-send-button.vue?vue&type=script&lang=js"
import style0 from "./part-send-button.vue?vue&type=style&index=0&id=da034a98&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da034a98",
  null
  
)

export default component.exports